import styled, { css } from 'styled-components';
import { ADigitSize, type ADigitProps } from './ADigit.types';
import { baseVariables } from '../../utils/TempMiUiLibraryUtils';

const { spacers } = baseVariables;

type StyleProps = Omit<ADigitProps, 'text'>;

const stylesBySize = ({ size = ADigitSize.Small }: StyleProps) => {
  return {
    ExtraLarge: css`
      padding-block-end: ${spacers?.spacers?.[2]};
      font-size: 5.625rem;
    `,
    Large: css`
      padding-block-end: ${spacers?.spacers?.[1]};
      font-size: 1.875rem;
    `,
    Medium: css`
      font-size: 1.375rem;
    `,
    Small: css`
      font-size: 1rem;
    `,
    ExtraSmall: css`
      font-size: 0.875rem;
    `,
  }[size];
};

export const ADigitWrapper = styled.span<StyleProps>`
  color: var(--t-brand-fg-color);
  font-family: var(--t-font-family);
  font-weight: 700;
  line-height: 1;
  display: inline-block;
  ${stylesBySize}
`;
